import { render, staticRenderFns } from "./avtList3.vue?vue&type=template&id=6b8b77ea&scoped=true"
import script from "./avtList3.vue?vue&type=script&lang=js"
export * from "./avtList3.vue?vue&type=script&lang=js"
import style0 from "./avtList3.vue?vue&type=style&index=0&id=6b8b77ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b77ea",
  null
  
)

export default component.exports